import React from 'react';

import './styles.css';

export const LoadingView: React.FC = () => {
  return (
    <div className='full-page-loading-container'>
      <div className='animating-m-container'>
        <svg height='57' viewBox='0 0 61 57' width='61' xmlns='http://www.w3.org/2000/svg'>
          <path
            className='path'
            d='M3.215 51.725V18.792c0-7.679 4.88-16.123 14.275-16.123s13.177 8.8 13.454 12.141c.278 3.34.853 26.304.853 31.276 0 4.973-2.796 7.398-6.741 7.629-3.405 0-5.088-1.99-5.947-4.112-.378-.934-.61-2.819 0-5.138.209-.797.77-2.089 1.68-3.876C34.48 19.944 42.137 8.626 43.762 6.633c2.915-3.293 5.616-3.51 7.376-3.402 4.904.044 6.57 5.198 6.607 7.957v40.537'
            fill='none'
            stroke='hsl(300, 1%, 85%)'
            strokeLinecap='square'
            strokeWidth='5'
          ></path>
        </svg>

        <svg height='57' viewBox='0 0 61 57' width='61' xmlns='http://www.w3.org/2000/svg' className='red-m'>
          <path
            className='path'
            d='M3.215 51.725V18.792c0-7.679 4.88-16.123 14.275-16.123s13.177 8.8 13.454 12.141c.278 3.34.853 26.304.853 31.276 0 4.973-2.796 7.398-6.741 7.629-3.405 0-5.088-1.99-5.947-4.112-.378-.934-.61-2.819 0-5.138.209-.797.77-2.089 1.68-3.876C34.48 19.944 42.137 8.626 43.762 6.633c2.915-3.293 5.616-3.51 7.376-3.402 4.904.044 6.57 5.198 6.607 7.957v40.537'
            fill='none'
            stroke='hsl(5, 88%, 47%)'
            strokeLinecap='square'
            strokeWidth='5'
          ></path>
        </svg>
      </div>
    </div>
  );
};
